
document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict(),
		postshome,
		singlepost_sidebar,
        posts_testimonials_training,
        postsevent,
        swiper_testimonials;

    postshome = new Swiper('.posts_home-slider', {
		observeSlideChildren: false,
		// slideToClickedSlide: true,
		updateOnWindowResize: true,
		slidesPerView: 1,
		spaceBetween: 30,
		autoHeight: true,
		// loop: true,
		speed: 1000,
		breakpoints: {
			320: {
				slidesPerView: 1,
                loop: true,
			},
			760: {
				slidesPerView: 2.3,
                loop: true,
			},
			1440: {
				slidesPerView: 2.3,
                loop: false,
			}
		},
		// autoplay: {
		// 	delay: 7000,
		// 	disableOnInteraction: false,
		// },
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: "fraction",
			// clickable: true,
		  },
		grabCursor: true
	});

    postsevent = new Swiper('.slider-posts.event-webinar .posts_home-slider', {
		observeSlideChildren: false,
		// slideToClickedSlide: true,
		updateOnWindowResize: true,
		slidesPerView: 1,
		spaceBetween: 30,
		autoHeight: true,
		loop: true,
		speed: 1000,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			760: {
				slidesPerView: 2.3
			},
			992: {
				slidesPerView: 3.3
			}
		},
		// autoplay: {
		// 	delay: 7000,
		// 	disableOnInteraction: false,
		// },
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: "fraction",
			// clickable: true,
		  },
		grabCursor: true
	});

    function swiperSinglePodscastResize() {
        if (window.innerWidth <= 520) {
            
            if (!$('.singlepost_sidebar .podcast-latest.post-list .items.container').hasClass('swiper-wrapper')) {
                $('.singlepost_sidebar .podcast-latest.post-list .items.container').addClass('swiper-wrapper');
                $('.singlepost_sidebar .podcast-latest.post-list .items.container > .item').addClass('swiper-slide');
                
                if ($('.singlepost_sidebar .podcast-latest.post-list .items.container .swiper-button-prev').length === 0) {
                    $('<div class="swiper-button-prev"></div><div class="swiper-pagination"></div><div class="swiper-button-next"></div>').insertAfter('.singlepost_sidebar .podcast-latest.post-list .items.container');
                }
            }
            
            if (singlepost_sidebar && singlepost_sidebar.destroy) {
                singlepost_sidebar.destroy(true, true);
            }
            
            setTimeout(function() {
                
                if ($('.singlepost_sidebar .podcast-latest.post-list').length > 0) {
                    singlepost_sidebar = new Swiper('.singlepost_sidebar .podcast-latest.post-list', {
                        observeSlideChildren: true,
                        // slideToClickedSlide: true,
                        updateOnWindowResize: true,
                        slidesPerView: 1,
                        spaceBetween: 30,
                        autoHeight: true,
                        loop: true,
                        speed: 1000,
                        // autoplay: {
                        //     delay: 7000,
                        //     disableOnInteraction: false,
                        // },
                        keyboard: {
                            enabled: true,
                            onlyInViewport: false,
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            type: "fraction",
                            // clickable: true,
                        },
                        grabCursor: true
                    });
                }
            }, 500);
        } else {

            if (singlepost_sidebar && singlepost_sidebar.destroy) {
                singlepost_sidebar.destroy(true, true);
                singlepost_sidebar = null;
            }
            $('.singlepost_sidebar .podcast-latest.post-list .items.container').removeClass('swiper-wrapper');
            $('.singlepost_sidebar .podcast-latest.post-list .items.container > .item').removeClass('swiper-slide');
            $('.singlepost_sidebar .wp-block-query .wp-block-post-template .swiper-button-prev, .singlepost_sidebar .swiper-pagination, .singlepost_sidebar .swiper-button-next').remove();
        }
    }

	function swiperSinglePostResize() {
        if (window.innerWidth <= 520) {
            
            if (!$('.singlepost_sidebar .wp-block-query .wp-block-post-template').hasClass('swiper-wrapper')) {
                $('.singlepost_sidebar .wp-block-query .wp-block-post-template').addClass('swiper-wrapper');
                $('.singlepost_sidebar .wp-block-query .wp-block-post-template > li').addClass('swiper-slide');
                
                if ($('.singlepost_sidebar .wp-block-query .wp-block-post-template .swiper-button-prev').length === 0) {
                    $('<div class="swiper-button-prev"></div><div class="swiper-pagination"></div><div class="swiper-button-next"></div>').insertAfter('.singlepost_sidebar .wp-block-query .wp-block-post-template');
                }
            }
            
            if (singlepost_sidebar && singlepost_sidebar.destroy) {
                singlepost_sidebar.destroy(true, true);
            }
            
            setTimeout(function() {
                
                if ($('.singlepost_sidebar .wp-block-query').length > 0) {
                    singlepost_sidebar = new Swiper('.singlepost_sidebar .wp-block-query', {
                        observeSlideChildren: true,
                        // slideToClickedSlide: true,
                        updateOnWindowResize: true,
                        slidesPerView: 1,
                        spaceBetween: 30,
                        autoHeight: true,
                        loop: true,
                        speed: 1000,
                        // autoplay: {
                        //     delay: 7000,
                        //     disableOnInteraction: false,
                        // },
                        keyboard: {
                            enabled: true,
                            onlyInViewport: false,
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            type: "fraction",
                            // clickable: true,
                        },
                        grabCursor: true
                    });
                }
            }, 500);
        } else {

            if (singlepost_sidebar && singlepost_sidebar.destroy) {
                singlepost_sidebar.destroy(true, true);
                singlepost_sidebar = null;
            }
            $('.singlepost_sidebar .wp-block-query .wp-block-post-template').removeClass('swiper-wrapper');
            $('.singlepost_sidebar .wp-block-query .wp-block-post-template > li').removeClass('swiper-slide');
            $('.singlepost_sidebar .wp-block-query .wp-block-post-template .swiper-button-prev, .singlepost_sidebar .swiper-pagination, .singlepost_sidebar .swiper-button-next').remove();
        }
    }
    
    swiperSinglePodscastResize();
    swiperSinglePostResize();
    
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            swiperSinglePodscastResize();
            swiperSinglePostResize();
        }, 250);
    });

    posts_testimonials_training = new Swiper('.posts-testimonials-training', {
		observeSlideChildren: false,
		// slideToClickedSlide: true,
		updateOnWindowResize: true,
		slidesPerView: 1,
		spaceBetween: 30,
		autoHeight: true,
		loop: true,
		speed: 1000,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			760: {
				slidesPerView: 2.3
			},
			992: {
				slidesPerView: 2.3
			}
		},
		// autoplay: {
		// 	delay: 7000,
		// 	disableOnInteraction: false,
		// },
		keyboard: {
			enabled: true,
			onlyInViewport: false,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		pagination: {
			el: '.swiper-pagination',
			type: "fraction",
			// clickable: true,
		  },
		grabCursor: true
	});

    // swiper_testimonials = new Swiper('.swiper-testimonials', {
	// 	observeSlideChildren: false,
	// 	// slideToClickedSlide: true,
	// 	// updateOnWindowResize: true,
	// 	slidesPerView: 1,
	// 	spaceBetween: 30,
	// 	// autoHeight: true,
	// 	loop: true,
	// 	speed: 1000,
	// 	breakpoints: {
	// 		320: {
	// 			slidesPerView: 1
	// 		},
	// 		760: {
	// 			slidesPerView: 2
	// 		},
	// 		992: {
	// 			slidesPerView: 3
	// 		}
	// 	},
	// 	// autoplay: {
	// 	// 	delay: 7000,
	// 	// 	disableOnInteraction: false,
	// 	// },
	// 	keyboard: {
	// 		enabled: true,
	// 		onlyInViewport: false,
	// 	},
	// 	navigation: {
	// 		nextEl: '.swiper-button-next',
	// 		prevEl: '.swiper-button-prev',
	// 	},
	// 	pagination: {
	// 		el: '.swiper-pagination',
	// 		type: "fraction",
	// 		// clickable: true,
	// 	  },
	// 	grabCursor: true
	// });

});